<template>
  <b-menu class="m-3" style="">
    <b-field v-if="!productsLoading && orgProducts(meOrg.id).length">
      <b-select placeholder="Produkt wählen" expanded v-model="selectedProduct">
        <template v-for="product in products">
          <option
            v-if="
              orgProducts(meOrg.id).includes(product.id) || isPermited('admin')
            "
            :value="product.id"
            :key="product.id"
          >
            {{ product.name }}
          </option>
        </template>
      </b-select>
    </b-field>
    <div
      v-if="productNavLoading"
      class="is-flex is-justify-content-center is-relative mt-2"
      style="height: 60px; width: 100%"
    >
      <b-loading
        :is-full-page="false"
        v-model="productNavLoading"
        :can-cancel="false"
      >
      </b-loading>
    </div>
    <template v-else>
      <div v-for="list in productNav(selectedProduct)" :key="list.id">
        <b-menu-list v-if="list.label">
          <template #label>{{ list.name }}</template>
          <MenuItem
            v-for="item in list.children"
            :key="item.id"
            :item="item"
            :product="productById(selectedProduct)"
          />
        </b-menu-list>
        <b-menu-list v-else>
          <MenuItem :item="list" :product="productById(selectedProduct)" />
        </b-menu-list>
      </div>
    </template>
    <b-menu-list label="Hilfe">
      <b-menu-item tag="router-link" :to="{ name: 'Contact' }">
        <template #label> Kontakt </template>
      </b-menu-item>
      <b-menu-item tag="router-link" :to="{ name: 'Disclaimer' }">
        <template #label> Disclaimer </template>
      </b-menu-item>
      <b-menu-item tag="router-link" :to="{ name: 'FAQ' }">
        <template #label> FAQ </template>
      </b-menu-item>
      <b-menu-item tag="router-link" :to="{ name: 'Imprint' }">
        <template #label> Impressum </template>
      </b-menu-item>
    </b-menu-list>
  </b-menu>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import MenuItem from '@/components/MenuItem.vue';

export default {
  name: 'Menu',
  components: {
    MenuItem,
  },
  methods: {
    ...mapMutations({
      selectProduct: 'menu/SET_SELECTED_PRODUCT',
    }),
  },
  computed: {
    ...mapGetters({
      products: 'product/data',
      productById: 'product/dataById',
      productsLoading: 'product/loading',
      productNav: 'product/nav/dataByParentId',
      productNavLoading: 'product/nav/loading',
      meOrg: 'org/me',
      orgProducts: 'org/product/dataByParentId',
      isPermited: 'user/isPermited',
    }),
    selectedProduct: {
      get() {
        return this.$store.getters['menu/selectedProduct'];
      },
      set(newValue) {
        localStorage.setItem('selectedProduct', newValue);
        this.selectProduct(newValue);
      },
    },
  },
  mounted() {
    if ('selectedProduct' in localStorage) {
      this.selectProduct(Number(localStorage.selectedProduct));
    }
  },
};
</script>
